import { EmployersRoutingModule } from "./employers-routing.module";
import { NgModule } from "@angular/core";
import { EditorModule } from "@tinymce/tinymce-angular";
import { EmployersComponent } from "./employers.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { CompleteProfileComponent } from "./complete-profile/complete-profile.component";
import { CommonModule } from "@angular/common";
import { PostAJobComponent } from "./post-a-job/post-a-job.component";
import { MatSelectModule } from "@angular/material/select";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { JobListingComponent } from "./job-listing/job-listing.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { EditPostJobComponent } from "./edit-post-job/edit-post-job.component";
import { AppliedCandidatesListComponent } from "./applied-candidates-list/applied-candidates-list.component";
import { AlertMessagesModule } from "../messages-helpers/messages-helpers.module";
import { PaginationModule } from "../pagination/pagination.module";
import { PaginationBsModule } from "../pagination-bs/pagination-bs.module";

@NgModule({
  declarations: [
    EmployersComponent,
    CompleteProfileComponent,
    PostAJobComponent,
    JobListingComponent,
    EditPostJobComponent,
    AppliedCandidatesListComponent,
  ],
  imports: [
    EditorModule,
    CommonModule,
    EmployersRoutingModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatToolbarModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatTabsModule,
    MatMenuModule,
    MatSelectModule,
    NgbModule,
    NgSelectModule,
    AlertMessagesModule,
    PaginationModule,
    PaginationBsModule,
  ],
  exports: [
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
  ],
  providers: [],
})
export class EmployersModule {}
